import axios from "axios";
import NProgress from "nprogress";


const apiClient = axios.create({
  baseUrl: "http://localhost:3000",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

const url = "https://www.wohnungsdatenbank.uni-freiburg.de/backend/Email/";


export default {
    sendMail(n,s,e,v = null,d = false){
        return apiClient.get(url + "dynamicMail.php", {
            params: {
                templatename: n,
                subject: s,
                empfaenger: e,
                variables: v,
                direkt: d
            }
          });
    },

    sendResetMail(type, hash, empf){
        return apiClient.get(url + "mail.php", {
            params: {
                resetHash: hash,
                type: type,
                empfaenger: empf,
            }
        });
    },

    getSystemMailList(){
        return apiClient.get(url + "systemMessages.php", {
            params: {
                type: 'list',
            }
        });
    },
    getSystemMailListVermieter(){
        return apiClient.get(url + "systemMessagesVermieter.php", {
            params: {
                type: 'list',
            }
        });
    },
    setSystemMailList(){
        return apiClient.get(url + "systemMessages.php", {
            params: {
                type: 'set',
            }
        });
    },
};